import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL } from "../config";
import dummyImg from "./images/profile-dummy.png";

const AllProfile = () => {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [filterGender, setFilterGender] = useState("");
    const [filterAgeRange, setFilterAgeRange] = useState("");
    const [filterCountry, setFilterCountry] = useState("");
    const [filterState, setFilterState] = useState("");
    const [filterDistrict, setFilterDistrict] = useState("");
    const [searchId, setSearchId] = useState("");
    const [districts, setDistricts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(4);
    const [totalPages, setTotalPages] = useState(1);

    const navigate = useNavigate();

    // Static data for countries
    const countries = ["India", "NRI"];

    // Districts by state (copied from RegisterFormMain)
    const districtsByState = {
        "Tamil Nadu": [
            "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
            "Dindigul", "Erode", "Kallakurichi", "Kanchipuram", "Kanyakumari", "Karur",
            "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
            "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
            "Tenkasi", "Thanjavur", "Theni", "Thiruvallur", "Thiruvarur", "Thiruvannamalai",
            "Thoothukudi", "Tiruchirappalli", "Tirunelveli", "Tirupathur", "Tiruppur",
            "Vellore", "Viluppuram", "Virudhunagar"
        ],
        "Kerala": [
            "Alappuzha", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kollam", "Kottayam",
            "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta", "Thiruvananthapuram",
            "Thrissur", "Wayanad"
        ],
        "Karnataka": [
            "Bagalkot", "Bangalore Rural", "Bangalore Urban", "Belagavi", "Ballari", "Bidar",
            "Chamarajanagar", "Chikkaballapur", "Chikkamagaluru", "Chitradurga",
            "Dakshina Kannada", "Davanagere", "Dharwad", "Gadag", "Hassan", "Haveri",
            "Kalaburagi", "Kodagu", "Kolar", "Koppal", "Mandya", "Mysuru", "Raichur",
            "Ramanagara", "Shivamogga", "Tumakuru", "Udupi", "Uttara Kannada", "Vijayapura",
            "Yadgir"
        ],
        "Andhra Pradesh": [
            "Anantapur", "Chittoor", "East Godavari", "Guntur", "Kadapa", "Krishna",
            "Kurnool", "Nellore", "Prakasam", "Srikakulam", "Visakhapatnam", "Vizianagaram",
            "West Godavari"
        ],
        "Arunachal Pradesh": [
            "Tawang", "West Kameng", "East Kameng", "Papum Pare", "Kurung Kumey", "Kra Daadi",
            "Lower Subansiri", "Upper Subansiri", "West Siang", "East Siang", "Upper Siang",
            "Lower Dibang Valley", "Anjaw", "Dibang Valley", "Lohit", "Namsai", "Changlang",
            "Tirap", "Longding"
        ],
        "Assam": [
            "Baksa", "Barpeta", "Biswanath", "Bongaigaon", "Cachar", "Charaideo", "Chirang",
            "Darrang", "Dhemaji", "Dhubri", "Dibrugarh", "Goalpara", "Golaghat", "Hailakandi",
            "Hojai", "Jorhat", "Kamrup Metropolitan", "Kamrup Rural", "Karbi Anglong",
            "Karimganj", "Kokrajhar", "Lakhimpur", "Majuli", "Morigaon", "Nagaon", "Nalbari",
            "Dima Hasao", "Sivasagar", "Sonitpur", "South Salmara-Mankachar", "Tinsukia",
            "Udalguri", "West Karbi Anglong"
        ],
        "Bihar": [
            "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur",
            "Buxar", "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad",
            "Kaimur", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura",
            "Madhubani", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia",
            "Rohtas", "Saharsa", "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi",
            "Siwan", "Supaul", "Vaishali", "West Champaran"
        ],
        "Chhattisgarh": [
            "Balod", "Baloda Bazar", "Balrampur", "Bastar", "Bemetara", "Bijapur", "Bilaspur",
            "Dantewada", "Dhamtari", "Durg", "Gariaband", "Gaurela-Pendra-Marwahi",
            "Janjgir-Champa", "Jashpur", "Kabirdham", "Kanker", "Kondagaon", "Korba", "Koriya",
            "Mahasamund", "Mungeli", "Narayanpur", "Raigarh", "Raipur", "Rajnandgaon",
            "Sukma", "Surajpur", "Surguja"
        ],
        "Goa": ["North Goa", "South Goa"],
        "Gujarat": [
            "Ahmedabad", "Amreli", "Anand", "Aravalli", "Banaskantha", "Bharuch", "Bhavnagar",
            "Botad", "Chhota Udaipur", "Dahod", "Dang", "Devbhumi Dwarka", "Gandhinagar",
            "Gir Somnath", "Jamnagar", "Junagadh", "Kachchh", "Kheda", "Mahisagar", "Mehsana",
            "Morbi", "Narmada", "Navsari", "Panchmahal", "Patan", "Porbandar", "Rajkot",
            "Sabarkantha", "Surat", "Surendranagar", "Tapi", "Vadodara", "Valsad"
        ],
        "Haryana": [
            "Ambala", "Bhiwani", "Charkhi Dadri", "Faridabad", "Fatehabad", "Gurugram",
            "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Mahendragarh",
            "Mewat", "Palwal", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat",
            "Yamunanagar"
        ],
        "Himachal Pradesh": [
            "Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kinnaur", "Kullu", "Lahaul and Spiti",
            "Mandi", "Shimla", "Sirmaur", "Solan", "Una"
        ],
        "Jharkhand": [
            "Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka", "East Singhbhum", "Garhwa",
            "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamtara", "Khunti", "Koderma",
            "Latehar", "Lohardaga", "Pakur", "Palamu", "Ramgarh", "Ranchi", "Sahibganj",
            "Seraikela-Kharsawan", "Simdega", "West Singhbhum"
        ],
        "Madhya Pradesh": [
            "Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Betul",
            "Bhind", "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh", "Datia",
            "Dewas", "Dhar", "Dindori", "Guna", "Gwalior", "Harda", "Hoshangabad", "Indore",
            "Jabalpur", "Jhabua", "Katni", "Khandwa", "Khargone", "Mandla", "Mandsaur",
            "Morena", "Narsinghpur", "Neemuch", "Panna", "Raisen", "Rajgarh", "Ratlam",
            "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur", "Sheopur",
            "Shivpuri", "Sidhi", "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha"
        ],
        "Maharashtra": [
            "Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara", "Buldhana",
            "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Hingoli", "Jalgaon", "Jalna",
            "Kolhapur", "Latur", "Mumbai City", "Mumbai Suburban", "Nagpur", "Nanded",
            "Nandurbar", "Nashik", "Osmanabad", "Palghar", "Parbhani", "Pune", "Raigad",
            "Ratnagiri", "Sangli", "Satara", "Sindhudurg", "Solapur", "Thane", "Wardha",
            "Washim", "Yavatmal"
        ],
        "Manipur": [
            "Bishnupur", "Chandel", "Churachandpur", "Imphal East", "Imphal West", "Jiribam",
            "Kakching", "Kamjong", "Kangpokpi", "Noney", "Pherzawl", "Senapati",
            "Tamenglong", "Tengnoupal", "Thoubal", "Ukhrul"
        ],
        "Meghalaya": [
            "East Garo Hills", "East Jaintia Hills", "East Khasi Hills", "North Garo Hills",
            "Ri-Bhoi", "South Garo Hills", "South West Garo Hills", "South West Khasi Hills",
            "West Garo Hills", "West Jaintia Hills", "West Khasi Hills"
        ],
        "Mizoram": [
            "Aizawl", "Champhai", "Hnahthial", "Khawzawl", "Kolasib", "Lawngtlai", "Lunglei",
            "Mamit", "Saiha", "Saitual", "Serchhip"
        ],
        "Nagaland": [
            "Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung", "Mon", "Peren", "Phek",
            "Tuensang", "Wokha", "Zunheboto"
        ],
        "Odisha": [
            "Angul", "Balangir", "Balasore", "Bargarh", "Bhadrak", "Boudh", "Cuttack",
            "Deogarh", "Dhenkanal", "Gajapati", "Ganjam", "Jagatsinghpur", "Jajpur",
            "Jharsuguda", "Kalahandi", "Kandhamal", "Kendrapara", "Kendujhar", "Khordha",
            "Koraput", "Malkangiri", "Mayurbhanj", "Nabarangpur", "Nayagarh", "Nuapada",
            "Puri", "Rayagada", "Sambalpur", "Subarnapur", "Sundergarh"
        ],
        "Punjab": [
            "Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Fazilka",
            "Ferozepur", "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana",
            "Mansa", "Moga", "Pathankot", "Patiala", "Rupnagar", "S.A.S. Nagar", "Sangrur",
            "Shahid Bhagat Singh Nagar", "Tarn Taran"
        ],
        "Rajasthan": [
            "Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Bharatpur", "Bhilwara",
            "Bikaner", "Bundi", "Chittorgarh", "Churu", "Dausa", "Dholpur", "Dungarpur",
            "Hanumangarh", "Jaipur", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu",
            "Jodhpur", "Karauli", "Kota", "Nagaur", "Pali", "Pratapgarh", "Rajsamand",
            "Sawai Madhopur", "Sikar", "Sirohi", "Sri Ganganagar", "Tonk", "Udaipur"
        ],
        "Sikkim": ["East Sikkim", "North Sikkim", "South Sikkim", "West Sikkim"],
        "Telangana": [
            "Adilabad", "Bhadradri Kothagudem", "Hyderabad", "Jagitial", "Jangaon",
            "Jayashankar Bhupalpally", "Jogulamba Gadwal", "Kamareddy", "Karimnagar",
            "Khammam", "Komaram Bheem Asifabad", "Mahabubabad", "Mahbubnagar", "Mancherial",
            "Medak", "Medchal–Malkajgiri", "Mulugu", "Nagarkurnool", "Nalgonda",
            "Narayanpet", "Nirmal", "Nizamabad", "Peddapalli", "Rajanna Sircilla",
            "Ranga Reddy", "Sangareddy", "Siddipet", "Suryapet", "Vikarabad", "Wanaparthy",
            "Warangal Rural", "Warangal Urban", "Yadadri Bhuvanagiri"
        ],
        "Tripura": [
            "Dhalai", "Gomati", "Khowai", "North Tripura", "Sepahijala", "South Tripura",
            "Unakoti", "West Tripura"
        ],
        "Uttar Pradesh": [
            "Agra", "Aligarh", "Ambedkar Nagar", "Amethi", "Amroha", "Auraiya", "Ayodhya",
            "Azamgarh", "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki",
            "Bareilly", "Basti", "Bhadohi", "Bijnor", "Budaun", "Bulandshahr", "Chandauli",
            "Chitrakoot", "Deoria", "Etah", "Etawah", "Farrukhabad", "Fatehpur",
            "Firozabad", "Gautam Buddh Nagar", "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur",
            "Hapur", "Hardoi", "Hathras", "Jalaun", "Jaunpur", "Jhansi", "Kannauj",
            "Kanpur Dehat", "Kanpur Nagar", "Kasganj", "Kaushambi", "Kheri", "Kushinagar",
            "Lalitpur", "Lucknow", "Maharajganj", "Mahoba", "Mainpuri", "Mathura", "Mau",
            "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Pilibhit", "Pratapgarh",
            "Prayagraj", "Rae Bareli", "Rampur", "Saharanpur", "Sambhal",
            "Sant Kabir Nagar", "Shahjahanpur", "Shamli", "Shravasti", "Siddharthnagar",
            "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"
        ],
        "Uttarakhand": [
            "Almora", "Bageshwar", "Chamoli", "Champawat", "Dehradun", "Haridwar",
            "Nainital", "Pauri Garhwal", "Pithoragarh", "Rudraprayag", "Tehri Garhwal",
            "Udham Singh Nagar", "Uttarkashi"
        ],
        "West Bengal": [
            "Alipurduar", "Bankura", "Birbhum", "Cooch Behar", "Dakshin Dinajpur",
            "Darjeeling", "Hooghly", "Howrah", "Jalpaiguri", "Jhargram", "Kalimpong",
            "Kolkata", "Malda", "Murshidabad", "Nadia", "North 24 Parganas",
            "Paschim Bardhaman", "Paschim Medinipur", "Purba Bardhaman", "Purba Medinipur",
            "Purulia", "South 24 Parganas", "Uttar Dinajpur"
        ],
        "Andaman and Nicobar Islands": [
            "North and Middle Andaman", "South Andaman", "Nicobar"
        ],
        "Chandigarh": ["Chandigarh"],
        "Daman and Diu": ["Daman", "Diu"],
        "Delhi": [
            "Central Delhi", "East Delhi", "New Delhi", "North Delhi", "North East Delhi",
            "North West Delhi", "Shahdara", "South Delhi", "South East Delhi",
            "South West Delhi", "West Delhi"
        ],
        "Jammu and Kashmir": [
            "Anantnag", "Bandipora", "Baramulla", "Budgam", "Doda", "Ganderbal", "Jammu",
            "Kathua", "Kishtwar", "Kulgam", "Kupwara", "Pulwama", "Rajouri", "Ramban",
            "Reasi", "Samba", "Shopian", "Srinagar", "Udhampur"
        ],
        "Ladakh": ["Kargil", "Leh"],
        "Puducherry": ["Karaikal", "Puducherry", "Yanam", "Mahe"]
    };

    // Fetch users
    const fetchUsers = useCallback(async () => {
        try {
            const response = await axios.get(`${BASE_URL}/fetchRegisteredUsers.php`);
            const data = Array.isArray(response.data?.data)
                ? response.data.data
                : Array.isArray(response.data)
                    ? response.data
                    : [];
            console.log("API Response Data:", data);
            if (data.length > 0) {
                console.log("Available user fields:", Object.keys(data[0]));
            } else {
                console.log("No user data received or data is not an array.");
            }
            setUsers(data);
        } catch (error) {
            console.error("Error fetching users:", error);
            setUsers([]);
            setFilteredUsers([]);
            setTotalPages(1);
        }
    }, []);

    // Calculate age
    const calculateAge = useCallback((dateOfBirth) => {
        if (!dateOfBirth) return null;
        try {
            const today = new Date();
            const birthDate = new Date(dateOfBirth);
            if (isNaN(birthDate.getTime())) {
                console.warn("Invalid date format for age calculation:", dateOfBirth);
                return null;
            }
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age >= 0 ? age : null;
        } catch (error) {
            console.error("Error calculating age for:", dateOfBirth, error);
            return null;
        }
    }, []);

    // Apply filters
    const applyFilters = useCallback(() => {
        console.log("applyFilters triggered. Current searchId:", searchId);
        let filteredData = [...users];

        // Gender filter
        if (filterGender) {
            filteredData = filteredData.filter(user => user.gender === filterGender);
        }

        // Age filter
        if (filterAgeRange) {
            const [minAgeStr, maxAgeStr] = filterAgeRange.split('-');
            if (minAgeStr && maxAgeStr) {
                const minAge = Number(minAgeStr);
                const maxAge = Number(maxAgeStr);
                filteredData = filteredData.filter(user => {
                    const userAge = calculateAge(user.dob);
                    return userAge !== null && userAge >= minAge && userAge <= maxAge;
                });
            }
        }

        // Country filter
        if (filterCountry) {
            filteredData = filteredData.filter(user =>
                user.country && user.country.toLowerCase() === filterCountry.toLowerCase()
            );
        }

        // State filter
        if (filterState) {
            console.log(filteredData,"filteredData")
            filteredData = filteredData.filter(user =>
                user.state && user.state.toLowerCase() === filterState.toLowerCase()
            );
        }

        // District filter
        if (filterDistrict) {
            filteredData = filteredData.filter(user =>
                user.living_place && user.living_place.toLowerCase() === filterDistrict.toLowerCase()
            );
        }

        // ID filter
        const idQuery = searchId.trim().toLowerCase();
        if (idQuery) {
            const idFields = [
                "id",
                "regNo",
                "user_id",
                "payment_unique_id",
                "registration_id"
            ];
            console.log(`Filtering by ID: Query='${idQuery}'`);
            filteredData = filteredData.filter((user) => {
                return idFields.some((field) => {
                    const userValue = user?.[field];
                    if (userValue !== null && userValue !== undefined) {
                        const userValueStr = userValue.toString().toLowerCase();
                        const match = userValueStr.includes(idQuery);
                        console.log(`Checking field '${field}': User Value='${userValueStr}', Includes Query='${idQuery}', Match=${match}`);
                        return match;
                    }
                    return false;
                });
            });
            console.log("Users remaining after ID filter:", filteredData.length);
        }

        setFilteredUsers(filteredData);
        setTotalPages(Math.ceil(filteredData.length / itemsPerPage));
        setCurrentPage(1);
    }, [users, filterGender, filterAgeRange, filterCountry, filterState, filterDistrict, searchId, itemsPerPage, calculateAge]);

    // Fetch users on mount
    useEffect(() => {
        
        fetchUsers();
    }, [fetchUsers]);

    // Update districts when state changes
    useEffect(() => {
        if (filterState) {
            setDistricts(districtsByState[filterState] || []);
            setFilterDistrict(""); // Reset district when state changes
        } else {
            setDistricts([]);
            setFilterDistrict("");
        }
    }, [filterState]);

    // Apply filters when any filter changes
    useEffect(() => {
        console.log("useEffect detected change, calling applyFilters...");
        applyFilters();
    }, [applyFilters]);

    const handleFilterButtonClick = () => {
        console.log("Filter button clicked manually, calling applyFilters...");
        applyFilters();
    };

    const currentItems = filteredUsers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleCardClick = (e, id) => {
        const loggedInUser = JSON.parse(localStorage.getItem('user'));
        const registered=sessionStorage.getItem('registered')
        
        if(registered=="true"  ){
            navigate('/verify-payment')
        }
        else if(registered=="payment"){
            navigate('/payment')
        }
        else if (!loggedInUser) {
            e.preventDefault();
            navigate('/SignUp');
        } else if (id) {
            localStorage.setItem('selectedUserId', id);
            navigate(`/user-details/${id}`);
        }
    };

    const handleClickNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleClickPrev = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    return (
        <div className="container mt-5">
            <div className="row mb-4 justify-content-center">
                <div className="col-12 mb-4 mt-3">
                    <h1 className="mb-0 text-center fw-bold">FIND YOUR MATCH HERE</h1>
                </div>
                <div className="col-12">
                    <div
                        className="d-flex flex-wrap justify-content-center align-items-center gap-3 p-3 text-white rounded"
                        style={{ backgroundColor: "#c86a00" }}
                    >
                        <div>
                            <select
                                className="form-select"
                                value={filterGender}
                                onChange={(e) => setFilterGender(e.target.value)}
                                style={{ minWidth: "150px" }}
                            >
                                <option value="">I'm looking for</option>
                                <option value="M">Male</option>
                                <option value="F">Female</option>
                            </select>
                        </div>

                        <div>
                            <select
                                className="form-select"
                                value={filterAgeRange}
                                onChange={(e) => setFilterAgeRange(e.target.value)}
                                style={{ minWidth: "150px" }}
                            >
                                <option value="">Age</option>
                                <option value="18-25">18-25</option>
                                <option value="26-35">26-35</option>
                                <option value="36-45">36-45</option>
                                <option value="46-60">46-60</option>
                            </select>
                        </div>

                        <div>
                            <select
                                className="form-select"
                                value={filterCountry}
                                onChange={(e) => {
                                    setFilterCountry(e.target.value);
                                    setFilterState(""); // Reset state when country changes
                                }}
                                style={{ minWidth: "150px" }}
                            >
                                <option value="">Select Country</option>
                                {countries.map((country) => (
                                    <option key={country} value={country}>
                                        {country}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <select
                                className="form-select"
                                value={filterState}
                                onChange={(e) => setFilterState(e.target.value)}
                                style={{ minWidth: "150px" }}
                                disabled={!filterCountry}
                            >
                                <option value="">Select State</option>
                                {Object.keys(districtsByState).map((state) => (
                                    <option key={state} value={state}>
                                        {state}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <select
                                className="form-select"
                                value={filterDistrict}
                                onChange={(e) => setFilterDistrict(e.target.value)}
                                style={{ minWidth: "150px" }}
                                disabled={!filterState}
                            >
                                <option value="">Select District</option>
                                {districts.map((district) => (
                                    <option key={district} value={district}>
                                        {district}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by ID"
                                value={searchId}
                                onChange={(e) => setSearchId(e.target.value)}
                                style={{ minWidth: '150px' }}
                            />
                        </div>

                        <button
                            className="btn btn-primary"
                            onClick={handleFilterButtonClick}
                            style={{ backgroundColor: "#2d4f07", borderColor: "#2d4f07" }}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="row profilecard-box">
                        {currentItems.length > 0 ? (

                            currentItems.map((user) => (
                                
                                <div key={user.id} className="col-md-3 mb-4">
                                    
                                    <div
                                        className="profile-card shadow-sm h-100"
                                        onClick={(e) => handleCardClick(e, user.id)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="card-image-wrapper">
                                            <img
                                                src={
                                                    user.profile_photo1 && user.profile_photo1.trim() !== ""
                                                        ? `${BASE_URL}/uploads/profile_photo1/${user.profile_photo1}`
                                                        : dummyImg
                                                }
                                                alt="Profile"
                                                className="card-img-top"
                                                onError={(e) => (e.target.src = dummyImg)}
                                            />
                                            <div className="image-overlay">
                                                <span className="view-profile">View Profile</span>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <h5 className="card-title">{user.fullname}</h5>
                                            <p className="card-text text-start">
                                                <span>User ID: </span>
                                                <b>{user.payment_unique_id || "Free User"}</b>
                                                <br />
                                                <span>Birth Place: </span> {user.birth_place} <br />
                                                <span>Job: </span> {user.job_type} <br />
                                                <span>Age: </span> {calculateAge(user.dob)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-center">No profiles found.</p>
                        )}
                    </div>
                </div>
            </div>

            {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                    <button
                        className="btn btn-primary me-2"
                        onClick={handleClickPrev}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span className="align-self-center">
                        {currentPage} of {totalPages}
                    </span>
                    <button
                        className="btn btn-primary ms-2"
                        onClick={handleClickNext}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default AllProfile;